<template>
  <div class="rb-ob-form rb-book-page">
    <h2 class="rb-ob-title">{{ $t('intake.portal.nextSessionPaymentResult') }}</h2>
    <p class="rb-ob-status" role="status" aria-live="polite">{{ message }}</p>
    <div v-if="status === 'PAYMENT_LATE'" class="rb-ob-actions">
      <router-link class="rb-ob-submit" :to="r('portalSupport')">{{ $t('intake.portal.nextSessionPaymentSupport') }}</router-link>
    </div>
    <div v-else-if="terminal" class="rb-ob-actions">
      <router-link class="rb-ob-submit" :to="r('portalNextSessionBooking')">{{ $t('intake.portal.nextSessionPickAgain') }}</router-link>
    </div>
    <button v-else-if="paused" class="rb-ob-submit" type="button" :disabled="resolving" @click="resume">
      {{ $t('intake.portal.nextSessionCheckStatus') }}
    </button>
  </div>
</template>

<script>
import {returnNextSessionPayment} from '@/intake/portalApi'

const MAX_POLLS = 48

export default {
  name: 'PortalNextSessionPayReturnStep',
  data() {
    return {status: 'PROCESSING', resolving: false, paused: false, attempts: 0, timer: null, error: '', disposed: false}
  },
  computed: {
    lang() { return this.$route.params.lang || 'fa' },
    terminal() { return ['CONFIRMED', 'CANCELLED', 'EXPIRED', 'PAYMENT_LATE'].includes(this.status) },
    message() {
      const key = {
        CONFIRMED: 'nextSessionConfirmed', CANCELLED: 'nextSessionPaymentFailed',
        EXPIRED: 'nextSessionPaymentExpired', PAYMENT_LATE: 'nextSessionPaymentLate',
      }[this.status] || (this.paused ? 'nextSessionPaymentPending' : 'nextSessionPaymentProcessing')
      return this.error || this.$t(`intake.portal.${key}`)
    },
  },
  mounted() { this.resolve() },
  beforeDestroy() { this.disposed = true; this.stop() },
  methods: {
    r(name) { return {name, params: {lang: this.lang}} },
    stop() { if (this.timer) window.clearTimeout(this.timer); this.timer = null },
    resume() { this.stop(); this.attempts = 0; this.paused = false; return this.resolve() },
    resolve() {
      if (this.resolving || this.disposed) return Promise.resolve()
      const query = this.$route.query || {}
      if (!query.episode_id || !query.hold_id) {
        this.error = this.$t('intake.portal.nextSessionUnavailable')
        this.status = 'CANCELLED'
        return Promise.resolve()
      }
      this.resolving = true
      this.attempts += 1
      this.error = ''
      return returnNextSessionPayment(query.episode_id, query.hold_id).then((hold) => {
        if (this.disposed) return
        this.status = hold.client_status || 'PROCESSING'
        if (this.status === 'CONFIRMED' && !hold.user_session_id) this.status = 'PROCESSING'
        if (this.status === 'CONFIRMED' && hold.user_session_id) {
          this.stop()
          return this.$router.replace(this.r('portalSessions'))
        }
      }).catch((e) => {
        if (!this.disposed && this.attempts >= MAX_POLLS) this.error = (e && e.message) || this.$t('intake.portal.nextSessionPaymentPending')
      }).finally(() => {
        this.resolving = false
        if (this.disposed || this.terminal) return
        if (this.attempts >= MAX_POLLS) { this.paused = true; return }
        this.timer = window.setTimeout(() => this.resolve(), 2500)
      })
    },
  },
}
</script>
